import * as React from 'react';
const CascaderContext = /*#__PURE__*/React.createContext({});
export default CascaderContext;